import foodBlocks from "./foodBlocks.json"

foodBlocks.splice(3, 0, foodBlocks[3])

export {foodBlocks}